module.exports = __webpack_public_path__ + "static/img/02.b474699.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/commodity/05/02.jpg
// module id = ggkT
// module chunks = 0